import { useTranslation } from "react-i18next";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "components/common/Button";
import type { HistoryPagerProps } from "./types";

export const HistoryPager = ({
  page,
  pageCount,
  onNewer,
  onOlder,
}: HistoryPagerProps) => {
  const { t } = useTranslation();

  // Past the first page the pager stays, so a page that failed to load still has a way back.
  if (pageCount <= 1 && page <= 1) return null;

  return (
    <nav className="flex items-center justify-between gap-2 border-b border-gray-200 px-4 py-2">
      <Button
        variant="text"
        size="sm"
        disabled={page <= 1}
        onClick={onNewer}
        startAdornment={<ChevronLeft size={16} />}
      >
        {t("smartSurveyor.history.newerPage")}
      </Button>
      {pageCount > 0 && (
        <span className="text-xs text-gray-500">
          {t("smartSurveyor.history.pageOf", { page, pageCount })}
        </span>
      )}
      <Button
        variant="text"
        size="sm"
        disabled={page >= pageCount}
        onClick={onOlder}
        endAdornment={<ChevronRight size={16} />}
      >
        {t("smartSurveyor.history.olderPage")}
      </Button>
    </nav>
  );
};
